import { Box, Button, Container, Grid, IconButton, TextField, } from "@mui/material";
import { useState } from "react";
import Page from "src/components/Page";
import "jspdf-autotable";
import useSettings from "src/hooks/useSettings";
import Iconify from "src/components/Iconify";

import WithoutPagination from "src/components/mrt-table/WithoutPagination";

import CreateOutWardOrder from "./create-outward-order";
import { useQuery } from "react-query";
import { getAllPartyOrder } from "src/pages/api";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { PATH_DASHBOARD } from "src/routes/paths";
import { size } from "lodash";
import ProductDetails from "./product-deatils";

export default function OutWardOrder() {
  const { themeStretch } = useSettings();
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const columns = [
    {
      accessorKey: "partyorderID",
      header: "Order ID",
      size : 100,
    },
    {
      accessorKey: "partyName",
      header: "Party Name",
    },
    {
      accessorKey: "createdDate",
      header: "Created Date",
      size: 150,
    },

    {
      accessorKey: "totalPrice",
      header: "Total Price",
      size: 100,
    },
  ];

  const { data } = useQuery({
    queryKey: ["getAllPartyOrder"],
    queryFn: getAllPartyOrder,
  });

  return (
    <>
      {open && (
        <CreateOutWardOrder
          onClose={() => {
            setOpen(false);
            setSelectedRow(null);
            setIsEditMode(false);
          }}
          row={selectedRow}
          isEditMode={isEditMode}
        />
      )}

      <Page title="General:Outward Order">
        <Container maxWidth={themeStretch ? false : "xl"} id={"report"}>
          <HeaderBreadcrumbs
            heading={`Outward Order`}
            links={[
              { name: "Dashboard", href: PATH_DASHBOARD.root },
              {
                name: "Inventory",
              },
              { name: "Outward Order" },
            ]}
          />

          <Box mt={4}>
            <WithoutPagination
              data={data?.data || []}
              columns={columns}
              loading={false}
              enableRowActions={false}
              // renderRowActions={({ row, table }) => (
              //   <Box sx={{ display: "flex", alignItems: "center" }}>
              //     <IconButton
              //       size="small"
              //       onClick={() => {
              //         selectedRow(row.original);
              //       }}
              //       color="primary"
              //     >
              //       <Iconify icon={"eva:edit-fill"} />
              //     </IconButton>
              //   </Box>
              // )}
              renderTopToolbarCustomActions={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    padding: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setOpen(true);
                      setIsEditMode(false);
                    }}
                  >
                    Add New
                  </Button>
                </Box>
              )}
              renderDetailPanel={({ row }) => (
                <ProductDetails row={row.original} />
              )}
              displayColumnDefOptions={{
                "mrt-row-actions": {
                  size: "100",
                },
              }}
            />
          </Box>
        </Container>
      </Page>
    </>
  );
}
